import { __read } from "tslib";
import { useMemoizedState } from '@office-start/hooks-utility';
import { useIdentity } from '@office-start/identity-service';
import { getUserItem } from '@office-start/web-storage-utility';
import { useEffect } from 'react';
import { SettingsCacheKeyPrefix } from '../models/Constants';
import { useEdgeworthRecent } from './useEdgeworthRecent';
/**
 * This hook exposes settings from Edgeworth API. There are a few important notes with using this API:
 * - Only use it for Edgeworth related features (Quick Access, My Content, Edgeworth) to persist data
 * - There is a max of 50 settings
 * - Key and value of a setting *each* has 1024 character limit
 * - New settings always get inserted at the front of the list
 * - The underlying storage for Edgeworth Settings is the Office Roaming service, which is also used by Office client apps
 * @returns Array of settings and setState callback to update settings in memory
 */
export function useEdgeworthSettings() {
    var recentData = useEdgeworthRecent().data;
    var identity = useIdentity().data;
    var memoizedSettings = useMemoizedState(recentData === null || recentData === void 0 ? void 0 : recentData.settings);
    var _a = __read(memoizedSettings, 2), settings = _a[0], setSettings = _a[1];
    useEffect(function () {
        if (!settings && identity) {
            var cachedSettings = getUserItem(identity.puid, SettingsCacheKeyPrefix);
            if (cachedSettings && cachedSettings.length) {
                setSettings(cachedSettings);
            }
        }
        // Fetch settings from cache only once per hook lifetime
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return memoizedSettings;
}
//# sourceMappingURL=useEdgeworthSettings.js.map